import React, { Component } from 'react';

import "./Buyers.scss"
import data from "../../api/data.json"
import { Link } from 'react-router-dom'

class Buyers extends Component {
  clickedPlaybuzz(btn)  {
    window.dataLayer.push({
      'event': 'GA_Event',
      'Category': 'isracard',
      'Action': 'PlayBuzz_Clicked',
      'Label': btn
    });
  }
  render() {
    return (
      <section className="section section-buyers">
        <div className="padding">
          <div className="side sideright">
            <Link to={data.buyers.men.link}>
              <div className="mlink" onClick={() => this.clickedPlaybuzz("men")}></div>
            </Link>
            <Link to={data.buyers.women.link}>
              <div className="wlink desc" onClick={() => this.clickedPlaybuzz("woman")}></div>
            </Link>
          </div>
          <div className="side sideleft">
            <Link to={data.buyers.men.link}>
              <div className="desc" onClick={() => this.clickedPlaybuzz("men")}></div>
            </Link>
          </div>
        </div>
      </section>
    );
  }
}

export default Buyers;



// WEBPACK FOOTER //
// ./src/components/Buyers/Buyers.js